module.exports = __webpack_public_path__ + "media/images/roku/TV3-ae964b5c21ae952469afe374580da8af.png";